import { Exclude } from 'class-transformer';

export class WFEWorkflowItemRawDto {
    description: string;
    itemAmount: number;
    glAccountNumber: string;
    subCategoryId: number;
    dimensions: string;
    crudAction: string;
    templateId: number;
    apBillItemId: number;
    targetCommunityId: number;
    crossAPBillId: number;
    crossAPBillItemId: number;

    // Transient properties
    @Exclude()
    itemId: number;

    @Exclude()
    sequence: number;
}
